import React from 'react';
import { motion } from 'framer-motion';
import { publicLayout, publicMotion, publicUi } from '../../styles/publicDesignSystem';

const PublicHeroShell = ({
  badge,
  badgeIcon: BadgeIcon,
  title,
  titleHighlight,
  subtitle,
  subtitleHighlight,
  primaryAction,
  secondaryAction,
  trustItems = [],
  visual,
  variant = 'default',
  backgroundLayer = null,
  contentAlign = 'left',
  className = ''
}) => {
  const isWhiteboard = variant === 'whiteboard';
  const hasVisual = Boolean(visual);
  const isCentered = contentAlign === 'center';

  return (
    <section className={`${publicUi.heroShell} ${isWhiteboard ? 'public-hero-shell-whiteboard' : ''} ${className}`}>
      {backgroundLayer ? (
        backgroundLayer
      ) : (
        <div className="absolute inset-0 opacity-10" aria-hidden="true">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml,%3Csvg width='72' height='72' viewBox='0 0 72 72' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.10'%3E%3Ccircle cx='36' cy='36' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")"
            }}
          />
        </div>
      )}

      <div
        className={`${publicLayout.container} ${
          isWhiteboard ? 'hero-whiteboard-inner py-10 lg:py-14' : 'py-20 lg:py-28'
        } relative z-10`}
      >
        <div className={`${publicUi.heroGrid} ${hasVisual ? '' : 'lg:grid-cols-1'}`}>
          <motion.div
            {...publicMotion.heroEnterLeft}
            className={`${publicUi.heroContent} ${hasVisual ? '' : 'lg:col-span-12 max-w-5xl'} ${isCentered ? 'mx-auto text-center' : ''}`}
          >
            {badge ? (
              <div
                className={`inline-flex items-center rounded-full px-4 py-2 text-sm font-medium mb-6 ${
                  isWhiteboard
                    ? 'bg-white/75 text-slate-700 border border-slate-200 shadow-sm'
                    : 'bg-white/15 border border-white/20'
                } ${isCentered ? 'mx-auto' : ''}`}
              >
                {BadgeIcon ? <BadgeIcon className="h-4 w-4 mr-2" /> : null}
                {badge}
              </div>
            ) : null}

            {title ? (
              <h1 className={`text-4xl lg:text-6xl font-bold leading-tight ${isWhiteboard ? 'text-slate-900 public-hero-whiteboard-heading' : ''}`}>
                {title}
                {titleHighlight ? (
                  <span className={`block ${isWhiteboard ? 'text-slate-700' : 'text-yellow-300'}`}>{titleHighlight}</span>
                ) : null}
              </h1>
            ) : null}

            {subtitle ? (
              <p className={`text-xl mt-6 max-w-2xl leading-relaxed ${isWhiteboard ? 'text-slate-700 public-hero-whiteboard-subtitle' : 'text-primary-100'} ${isCentered ? 'mx-auto' : ''}`}>
                {subtitle}
                {subtitleHighlight ? (
                  <span className={`block mt-2 font-semibold ${isWhiteboard ? 'text-slate-900' : 'text-yellow-300'}`}>
                    {subtitleHighlight}
                  </span>
                ) : null}
              </p>
            ) : null}

            <div className={`mt-8 flex flex-col sm:flex-row gap-4 ${isCentered ? 'justify-center items-center' : ''}`}>
              {primaryAction}
              {secondaryAction}
            </div>

            {trustItems.length ? (
              <div className={`mt-8 flex flex-wrap gap-6 text-sm ${isWhiteboard ? 'text-slate-600' : 'text-primary-100'} ${isCentered ? 'justify-center' : ''}`}>
                {trustItems.map((item) => (
                  <div key={item.key || item.text} className="flex items-center gap-2">
                    {item.icon ? <item.icon className={`h-4 w-4 ${isWhiteboard ? 'text-emerald-600' : 'text-green-300'}`} /> : null}
                    <span>{item.text}</span>
                  </div>
                ))}
              </div>
            ) : null}
          </motion.div>

          {hasVisual ? (
            <motion.div {...publicMotion.heroEnterRight} className={publicUi.heroVisual}>
              {visual}
            </motion.div>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default PublicHeroShell;
